export const getErrorMessage = (error: unknown): string => {
  if (!error) return 'Terjadi kesalahan yang tidak diketahui';

  if (error instanceof Error) {
    const message = error.message?.toLowerCase() || '';

    if (message.includes('network') || message.includes('fetch')) {
      return 'Koneksi terputus - Periksa koneksi internet Anda';
    }

    if (message.includes('timeout')) {
      return 'Permintaan timeout - Coba lagi dalam beberapa saat';
    }

    if (message.includes('unauthorized') || message.includes('401')) {
      return 'Sesi Anda telah berakhir - Silakan login kembali';
    }

    if (message.includes('forbidden') || message.includes('403')) {
      return 'Akses ditolak - Anda tidak memiliki izin untuk mengakses';
    }

    if (message.includes('not found') || message.includes('404')) {
      return 'Data tidak ditemukan';
    }

    if (message.includes('server') || message.includes('500')) {
      return 'Server sedang bermasalah - Coba lagi nanti';
    }

    return error.message;
  }

  return 'Gagal memproses permintaan - Coba lagi';
};
